import { render, staticRenderFns } from "./ItemChangelog.vue?vue&type=template&id=269da52d&"
import script from "./ItemChangelog.vue?vue&type=script&lang=js&"
export * from "./ItemChangelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports